(function () {
  document.querySelectorAll('.jb-pdp').forEach(function (root) {
    if (root.dataset.jbBound) return;
    root.dataset.jbBound = '1';

    var dataEl = root.querySelector('[data-jb-pdp-data]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}

    // Image gallery
    var mainImg = root.querySelector('#jb-pdp-main-img');
    if (mainImg) mainImg.removeAttribute('srcset');
    root.querySelectorAll('[data-jb-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        root.querySelectorAll('[data-jb-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) mainImg.src = thumb.dataset.full;
      });
    });

    // Variant picker
    var selected = [];
    root.querySelectorAll('.jb-pdp__option').forEach(function (opt, i) {
      var active = opt.querySelector('.jb-pdp__swatch.is-active');
      selected[i] = active ? active.dataset.value : '';
    });

    function findVariant() {
      return variants.find(function (v) {
        return (v.option1 || '') === (selected[0] || '') &&
               (v.option2 || '') === (selected[1] || '') &&
               (v.option3 || '') === (selected[2] || '');
      });
    }

    function fmtMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateUI() {
      var v = findVariant();
      var idInput = root.querySelector('[data-jb-variant-id]');
      var atcBtn = root.querySelector('[data-jb-atc-btn]');
      var atcText = root.querySelector('[data-jb-atc-text]');
      var priceEl = root.querySelector('[data-jb-price]');
      var compareEl = root.querySelector('[data-jb-compare]');

      if (!v) {
        if (atcBtn) { atcBtn.disabled = true; }
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (atcBtn) atcBtn.disabled = !v.available;
      if (atcText) atcText.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceEl) priceEl.textContent = fmtMoney(v.price);
      if (compareEl && v.compare_at_price && v.compare_at_price > v.price) {
        compareEl.textContent = fmtMoney(v.compare_at_price);
      }
      // featured image swap
      if (v.featured_image && v.featured_image.src && mainImg) {
        var url = v.featured_image.src;
        if (url.indexOf('?') === -1) { url = url.replace(/(\.[a-z]+)$/i, '_1200x$1'); }
        mainImg.src = url;
      }
    }

    root.querySelectorAll('[data-jb-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var idx = parseInt(sw.dataset.optionIndex, 10);
        selected[idx] = sw.dataset.value;
        // toggle active in same group
        sw.closest('.jb-pdp__option').querySelectorAll('.jb-pdp__swatch').forEach(function (s) {
          s.classList.toggle('is-active', s === sw);
        });
        // update label
        var lbl = sw.closest('.jb-pdp__option').querySelector('[data-jb-option-value]');
        if (lbl) lbl.textContent = sw.dataset.value;
        updateUI();
      });
    });

    // Qty +/-
    var qtyInput = root.querySelector('[data-jb-qty-input]');
    var qtyDown = root.querySelector('[data-jb-qty-down]');
    var qtyUp = root.querySelector('[data-jb-qty-up]');
    if (qtyDown && qtyInput) qtyDown.addEventListener('click', function () {
      var v = Math.max(1, parseInt(qtyInput.value, 10) - 1); qtyInput.value = v;
    });
    if (qtyUp && qtyInput) qtyUp.addEventListener('click', function () {
      var v = parseInt(qtyInput.value, 10) + 1; qtyInput.value = v;
    });

    // AJAX add to cart: desktop = fly-to-cart animation, mobile = open drawer
    var form = root.querySelector('.jb-pdp__form');
    var atcBtn = root.querySelector('[data-jb-atc-btn]');
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); e.stopPropagation(); });
    if (form && atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var btn = atcBtn;
        var txt = root.querySelector('[data-jb-atc-text]');
        if (btn.disabled) return;
        var original = txt ? txt.textContent : '';
        btn.disabled = true;
        if (txt) txt.textContent = 'Adding…';
        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            window.jbAddedToCart(mainImg);
            if (txt) txt.textContent = 'Added ✓';
            setTimeout(function () { if (txt) txt.textContent = original; btn.disabled = false; }, 1400);
          })
          .catch(function () {
            if (txt) txt.textContent = 'Try again';
            setTimeout(function () { if (txt) txt.textContent = original; btn.disabled = false; }, 1400);
          });
      });
    }

    // Buy it now
    var buyNow = root.querySelector('[data-jb-buy-now]');
    if (buyNow) buyNow.addEventListener('click', function () {
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: fd
      }).then(function () { window.location.href = '/checkout'; });
    });
  });
})();

// JB: after an add on the product page.
// Desktop (990px+): product image flies into the header cart, cart icon turns green and pops. No drawer.
// Mobile: opens the cart drawer as before.
window.jbAddedToCart = function (img) {
  if (!window.matchMedia('(min-width: 990px)').matches) {
    document.dispatchEvent(new CustomEvent('cart:open'));
    return;
  }
  var icon = Array.prototype.filter.call(document.querySelectorAll('[data-js-cart-icon]'), function (el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  })[0];
  if (!document.getElementById('jb-cart-fx-css')) {
    var st = document.createElement('style');
    st.id = 'jb-cart-fx-css';
    st.textContent =
      '.jb-cart-hit{color:#4ade80!important;animation:jbCartPop .7s cubic-bezier(.3,1.6,.5,1)}' +
      '.jb-cart-hit .header__cart-count{background:#22c55e!important;color:#0e0c14!important}' +
      '@keyframes jbCartPop{0%{transform:scale(1)}30%{transform:scale(1.35) rotate(-8deg)}55%{transform:scale(.9) rotate(4deg)}75%{transform:scale(1.12)}100%{transform:scale(1)}}' +
      '.jb-cart-hit::after{content:"";position:absolute;inset:8px;border-radius:50%;border:2px solid #4ade80;animation:jbCartRing .8s ease-out forwards;pointer-events:none}' +
      '@keyframes jbCartRing{0%{transform:scale(.6);opacity:1}100%{transform:scale(1.9);opacity:0}}' +
      '.jb-cart-fly{position:fixed;z-index:999999;border-radius:50%;object-fit:cover;pointer-events:none;box-shadow:0 8px 24px rgba(14,12,20,.25);border:2px solid #fff;background:#fff}';
    document.head.appendChild(st);
  }
  function hit() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-js-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      }).catch(function () {});
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (!icon) return;
    icon.classList.remove('jb-cart-hit');
    void icon.offsetWidth;
    icon.classList.add('jb-cart-hit');
    clearTimeout(icon._jbT);
    icon._jbT = setTimeout(function () { icon.classList.remove('jb-cart-hit'); }, 1800);
  }
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!icon || !img || reduce || !img.animate) { hit(); return; }
  var s = img.getBoundingClientRect(), e = icon.getBoundingClientRect(), size = 90;
  var fly = document.createElement('img');
  fly.src = img.currentSrc || img.src;
  fly.className = 'jb-cart-fly';
  fly.style.width = size + 'px';
  fly.style.height = size + 'px';
  var sx = s.left + s.width / 2 - size / 2, sy = s.top + s.height / 2 - size / 2;
  var dx = (e.left + e.width / 2 - size / 2) - sx, dy = (e.top + e.height / 2 - size / 2) - sy;
  fly.style.left = sx + 'px';
  fly.style.top = sy + 'px';
  document.body.appendChild(fly);
  var anim = fly.animate([
    { transform: 'translate(0,0) scale(1)', opacity: 1 },
    { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 120) + 'px) scale(.7)', opacity: 1, offset: 0.55 },
    { transform: 'translate(' + dx + 'px,' + (dy - 40) + 'px) scale(.3)', opacity: 1, offset: 0.85 },
    { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: 0 }
  ], { duration: 800, easing: 'cubic-bezier(.45,0,.25,1)' });
  anim.onfinish = function () { fly.remove(); hit(); };
};
